import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { bootstrapTelegramUI } from '../../shared/telegram.ts'
import './i18n'
import '../../shared/tokens.css'
import '../../shared/shell.css'
import './index.css'
import '../../shared/game-polish.css'
import '@shared/folded-veil.css'
import '../../shared/game-polish-refine.css'
import '../../shared/brand.css'
import '../../shared/snowfold-village.css'
import '@shared/reference-layout.css'
import './dice-layout.css'
import './dice-effects.css'
import '../../shared/game-header.css'
import '../../shared/bottom-sheet.css'
import '../../shared/bet-dock.css'
import '../../shared/single-viewport.css'
import './dice-stage.css'
import App from './App'

bootstrapTelegramUI()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
